module.exports = __webpack_public_path__ + "img/MEGA.60ea31fe.png";